module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_6005.6493d7c8.png";